import { FilterConfig } from '../../../../model/filter';
import { ServiceActionType, ServicesFilterNames } from '../../../../utils/enums';
import { ServiceAndStatus } from '../../../../dtos/service-with-status.dto';
import { Rule, Service } from '../../../../dtos/version.dto';
import { isServiceHasRule } from '../../../../utils/versionUtils';
import { RuleHelper, RuleNameAlias } from '../../../../utils/rule-helper';

export const servicesFiltersConfig: FilterConfig<ServiceAndStatus> = {
    searchBox: { placeholder: 'Search Services', byFields: ['name', 'subName'] },
    localStorageKey: 'serviceDefaultFilter',
    dropdownList: [
        {
            name: 'Action',
            options: [
                { label: ServicesFilterNames.All, filterFn: () => true },
                { label: ServicesFilterNames.Blocked, filterFn: (service: ServiceAndStatus) =>
                        service.outboundState === ServiceActionType.BLOCK || service.inboundState === ServiceActionType.BLOCK },
                { label: ServicesFilterNames.Allowed, filterFn: (service: ServiceAndStatus) =>
                        service.outboundState === ServiceActionType.ALLOW || service.inboundState === ServiceActionType.ALLOW},
                { label: ServicesFilterNames.NOT_APPLY, filterFn: (service: ServiceAndStatus) =>
                        service.outboundState === ServiceActionType.NOT_APPLY || service.inboundState === ServiceActionType.NOT_APPLY}
            ]
        },
        {
            name: 'Origin',
            matchWidth: false,
            options: [
                { label: ServicesFilterNames.All, filterFn: () => true },
                { label: ServicesFilterNames.Default, filterFn: (service: ServiceAndStatus) => !service.isCustom },
                { label: ServicesFilterNames.Custom, filterFn: (service: ServiceAndStatus) => service.isCustom}
            ]
        }
    ]
};

export const inventoryServicesFiltersConfig = (servicesRules: Rule[]): FilterConfig<Service> => {

    const relevantRules = new Set([RuleHelper.getRuleName(RuleNameAlias.TRUST_TO_UNTRUST_SERVICES),
        RuleHelper.getRuleName(RuleNameAlias.ALLOW_UNTRUST_TO_TRUST_NON_WEB_SERVICES),
        RuleHelper.getRuleName(RuleNameAlias.UNTRUST_TO_TRUST_SERVICES),
        RuleHelper.getRuleName(RuleNameAlias.ALLOW_TRUST_TO_UNTRUST_NON_WEB_SERVICES)]);

    const filteredServiceRules = servicesRules.filter(rule => relevantRules.has(rule.displayName));
    return {
        searchBox: {placeholder: 'Search Services', byFields: ['displayName', 'description', 'proto', 'sports', 'dports', 'sports']},
        multipleDropdownList: [
            {
                name: 'Rules',
                matchWidth: false,
                options: [
                    ...filteredServiceRules.map(rule => {
                        return { label: rule.displayName, filterFn: (service: Service) => isServiceHasRule(rule, service)};
                    })
                ]
            }
        ]
    };
};